const googleAnalyticsCode = APP_CONFIG.googleAnalytics;

export function createEvent(categoryValue, actionValue, labelValue, userData) {

  if (window.gtag) {
    const userProperties = {
      'opcoId': userData.opcoId,
      'syscoCustomerId': userData.syscoCustomerId,
      'emailAddress': userData.emailAddress,
      'role': userData.role,
      'firstName': userData.firstName,
      'source': userData.source,
      'userId': userData.id
    }
  
    gtag('set', 'user_properties', userProperties);
  
    gtag('set', {
      'user_id': userData.id
    });
  
    gtag('event', categoryValue, {
      'event_action': actionValue,
      'event_label': labelValue
    });

  }

}
